// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useCallback, useState } from 'react';

/**
 * A React hook that manages the open / closed state of a disclosure.
 *
 * `open` and `close` are stable across renders so callers can use them
 * as useEffect / useMemo / useCallback dependencies without defeating
 * the memoization.
 */
export function useDisclosure(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { isOpen, open, close };
}
